import React from "react";
import {
  Flex,
  Box,
  InputRightAddon,
  InputGroup,
  Stack,
} from "@chakra-ui/react";
import { useGetprofileQuery } from "../../../api/profile.api";
import DateObject from "react-date-object";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";

const UserDetails = () => {

  const { data, isLoading } = useGetprofileQuery();
  const birthDate = data?.dateOfBirth??''
  let date = new DateObject(birthDate);
    console.log("date", date.convert(persian).format());
    const humanReadableDate = date.convert(persian).format()

    // const humanReadableDate = new Date(data?.dateOfBirth).toLocaleDateString(
    //   "en-us",
    //   {
    //     day: "numeric",
    //     month: "long",
    //     year: "numeric",
    //   }
    // );
    


  return (
    <Box className="userDetails-wrapper">
      <Flex className="user">
        <Stack spacing={5}>
          <InputGroup className="userInput-card">
            <div>
              <InputGroup>
                <InputRightAddon children="نام" />
                {/* <Input value="علی" /> */}
                <div className="userDetail-card">{data?.firstName}</div>
              </InputGroup>
            </div>

            <div>
              <InputGroup>
                <InputRightAddon children="نام خانوادگی" />
                {/* <Input value="بهرامی" /> */}
                <div className="userDetail-card">{data?.lastName}</div>
              </InputGroup>
            </div>
          </InputGroup>

          <InputGroup className="userInput-card">
            <div>
              <InputGroup>
                <InputRightAddon children="کد ملی" />
                {/* <Input value="0056815554" /> */}
                <div className="userDetail-card">{data?.nationalId}</div>
              </InputGroup>
            </div>

            <div>
              <InputGroup>
                <InputRightAddon children="تاریخ تولد" />
                {/* <Input value="1367/10/7" /> */}
                <div className="userDetail-card">{humanReadableDate}</div>
              </InputGroup>
            </div>
          </InputGroup>

          <InputGroup className="userInput-card">
            <div>
              
              <InputGroup>
                <InputRightAddon children="مدرک تحصیلی" />
                {/* <Input value="لیسانس" /> */}
                <div className="userDetail-card">{data?.educationLicense}</div>
              </InputGroup>
            </div>

            <div>
              <InputGroup>
                <InputRightAddon children="موبایل" />
                {/* <Input value="09065659923" /> */}
                <div className="userDetail-card">
                  {data?.secondaryPhoneNumber}
                </div>
              </InputGroup>
            </div>
          </InputGroup>

          <InputGroup id="address">
            <InputGroup>
              <InputRightAddon children="آدرس" />
              {/* <Input value="لیسانس" /> */}
              <div className="userDetail-card-address">{data?.address}</div>
            </InputGroup>
          </InputGroup>
        </Stack>
      </Flex>
    </Box>
  );
};

export default UserDetails;
